import { useEffect } from 'react';

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '黑料吃瓜网',
  url: 'http://cgshe.cn/',
  description: '全网最新网红黑料与娱乐八卦资讯平台，7×24小时不间断更新，第一时间捕捉劲爆内容。',
  logo: 'http://cgshe.cn/logo.png',
  sameAs: ['http://cgshe.cn/'],
  contactPoint: {
    '@type': 'ContactPoint',
    email: 'hello@cgshe.cn',
    contactType: 'customer service',
    availableLanguage: ['Chinese'],
  },
};

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '黑料吃瓜网',
  url: 'http://cgshe.cn/',
  description: '黑料吃瓜网官网直连黑料吃瓜网站、黑料吃瓜网www与黑料吃瓜网曝一区二区等热门板块，第一时间捕捉全网最新网红黑料。',
  inLanguage: 'zh-CN',
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: 'http://cgshe.cn/search?q={search_term_string}',
    },
    'query-input': 'required name=search_term_string',
  },
};

export default function SiteSchema() {
  useEffect(() => {
    const schemas = [organizationSchema, websiteSchema];
    schemas.forEach((schema, index) => {
      const scriptId = `site-schema-${index}`;
      let script = document.getElementById(scriptId);
      if (!script) {
        script = document.createElement('script');
        script.id = scriptId;
        script.setAttribute('type', 'application/ld+json');
        document.head.appendChild(script);
      }
      script.textContent = JSON.stringify(schema);
    });
  }, []);

  return null;
}